// SuggestedPrompts.js
import React from 'react';
import './SuggestedPrompts.scss';

const SuggestedPrompts = ({ onClick, submitCounter, onResetSubmitCounter}) => {
  const getSuggestedPrompts = () => {
    switch (submitCounter) {
      case 1:
        return {
          headingText: "Additional questions",
          prompts: [
            { label: "Can you explain in layman's terms what a cookie and IP address is?", input: "Can you explain in layman's terms what a cookie and IP address is?", type: "chat" },
            { label: "How do I understand which personal information is actually sold and shared?", input: "How do I understand which personal information is actually sold and shared?", type: "chat" },
            { label: "If I've given personal information, is there a way to remove it?", input: "If I've given personal information, is there a way to remove it?", type: "chat" },
            { label: "Learn About Another Privacy Policy", input: "Learn About Another Privacy Policy", type: "chat"},
          ],
        };
      default:
        return {
          headingText: "",
          prompts: [
            { label: "Learn About Another Privacy Policy", input: "Learn About Another Privacy Policy", type: "chat"},
          // Add more suggested prompts for case 2
          ],
        };
      // Add more cases as needed
      case 0:
        return {
          headingText: "Or select one of the following:",
          prompts: [
            { label: "Google Privacy Policy", input: "https://policies.google.com/privacy?hl=en-US", type: "retrieve" },
            { label: "Facebook Privacy Policy", input: "https://www.facebook.com/privacy/policy/", type: "retrieve" },
            { label: "Apple Privacy Policy", input: "https://www.apple.com/legal/privacy/en-ww/", type: "retrieve" },
            { label: "Microsoft Privacy Policy", input: "https://privacy.microsoft.com/en-us/privacystatement", type: "retrieve" },
          ],
        };
    }
  };

  const { headingText, prompts } = getSuggestedPrompts();

  const handleButtonClick = (input) => {
      if (submitCounter > 0 && input === "Learn About Another Privacy Policy") {
        onResetSubmitCounter();
      } else {
        onClick(input);
      }
  };

  return (
        <div className="suggested-prompts-wrapper">
          <p className="prompts-label">{headingText}</p>
          <div className="suggested-prompts">
            {prompts.map((suggestedPrompt, index) => (
              <div key={index} className="suggested-item" onClick={() => handleButtonClick(suggestedPrompt.input)}>
                <span>{suggestedPrompt.label} </span>
              </div>
            ))}
          </div>
        </div>
      );
};

export default SuggestedPrompts;
